import React, { useEffect, useState } from "react";
import { Flex, Collapse, Typography, Modal } from "antd";
import { toast } from "react-toastify";
import { customLogger } from "../../../../../utils/Logger";
import CustomLoader from "../../../../common/UI/Loader";
import ENDPOINTS from "../../../../../services/endpoint";
import apiInstance from "../../../../../services/apiService";
import BuyNumbers from "../../../../../pages/Settings/BuyNumber";
import AddonCard from "../../../../common/AddonCard";
import SettingsSidebarHeader from "../../../../common/SettingsSidebarHeader";
import "./index.scss";

const { Text } = Typography;

interface SMSAddonProps {
  handleBackToPrevious: () => void;
  phoneNumberToUpdate?: string;
}

interface Country {
  countryCode: number;
  countryName: string;
  isoCode: string;
  iso3Code: string;
}

interface SMSAddon {
  addonId: string;
  addonName: string;
  addonCost: string;
  isAssigned: boolean;
  countries: Country[];
}

interface PurchasedNumber {
  _id: string;
  isFreeCall: boolean;
  isPrimary: boolean;
  isSMS: boolean;
  iseFoneNumber: boolean;
  phoneNumber: string;
  SMSaddons: SMSAddon[];
}

const SMSAddons: React.FC<SMSAddonProps> = ({
  handleBackToPrevious,
  phoneNumberToUpdate,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [purchasedNumbersList, setPurchasedNumbersList] = useState<
    PurchasedNumber[] | null
  >(null);
  const [subscribeInProcess, setSubsribeInProcess] = useState<boolean>(false);
  const [activeKey, setActiveKey] = useState<string | string[]>();
  const [unassignedAddonsLength, setUnAssignedAddonsLength] =
    useState<number>(0);
  const [paymentGatewayModalOpen, setPaymentGatewayModalOpen] =
    useState<boolean>(false);
  const [paymentGatewayDetails, setPaymentGatewayDetails] = useState<any>(null);

  const getAddons = async () => {
    const url = ENDPOINTS.GET_PURCHASED_NUMBERS;

    setLoading(true);
    try {
      const response = await apiInstance.get(url);
      const data = response.data.data;
      setPurchasedNumbersList(data);
    } catch (error: any) {
      console.error(error);
      toast.error(error.msg || "There was an error fetching addons");
    } finally {
      setLoading(false);
    }
  };

  const handleSubscribe = async (item: SMSAddon, smsPhoneNumber: any) => {
    const url = ENDPOINTS.CANCEL_SMS;

    setSubsribeInProcess(true);
    try {
      const response = await apiInstance.post(url, {
        phoneId: smsPhoneNumber?._id || "",
        addonId: item.addonId,
      });
      const message = response.data.message;
      toast.success(message || "subscribed successfulyy");
      getAddons();
    } catch (error: any) {
      if (error.status === 400 && error?.response?.data?.hostedpageDetails) {
        toast.info("First add  card from subscription page  for purchasing.");
        setPaymentGatewayDetails(error?.response.data.hostedpageDetails);
        setPaymentGatewayModalOpen(true);
      } else {
        toast.error(error.response.data.message || "Failed to subscribe");
      }
    } finally {
      setSubsribeInProcess(false);
    }
  };

  const customHeader = (title: string) => (
    <div className="custom-header">
      <span>{title}</span>
    </div>
  );

  useEffect(() => {
    getAddons();
  }, []);

  useEffect(() => {
    if (phoneNumberToUpdate) {
      setActiveKey([phoneNumberToUpdate]);
    }
  }, [phoneNumberToUpdate]);

  useEffect(() => {
    if (!purchasedNumbersList) return;
    const unassignedAddons = purchasedNumbersList.flatMap(
      (number: any) =>
        number.SMSaddons?.filter((addon: any) => !addon.isAssigned) || []
    );
    setUnAssignedAddonsLength(unassignedAddons.length);
  }, [purchasedNumbersList]);

  return (
    <div className="sms-addons-container">
      <SettingsSidebarHeader
        title="SMS Addons"
        handleBackClick={handleBackToPrevious}
      />

      <div className="main-section">
        {loading ? (
          <Flex justify="center" align="center">
            <CustomLoader />
          </Flex>
        ) : purchasedNumbersList && unassignedAddonsLength > 0 ? (
          <>
            <Text className="hero-text">
              Choose SMS addon for purchased numbers
            </Text>
            <Collapse
              accordion
              expandIconPosition="end"
              className="custom-collapse sms-addon-collapse"
              {...(phoneNumberToUpdate ? { activeKey } : {})}
              onChange={(key) => {
                customLogger(key);
                setActiveKey(key);
              }}
              items={purchasedNumbersList
                ?.map((number: any) => {
                  const unassignedAddons = number.SMSaddons.filter(
                    (addon: any) => !addon.isAssigned
                  );

                  if (unassignedAddons.length === 0) return null;

                  return {
                    key: number?._id,
                    label: customHeader(number?.phoneNumber),
                    children: unassignedAddons.map((addon: any) => (
                      <AddonCard
                        isHighlighted={
                          phoneNumberToUpdate
                            ? activeKey?.includes(phoneNumberToUpdate)
                            : false
                        }
                        loading={subscribeInProcess}
                        addon={addon}
                        smsPhoneNumber={number}
                        onSubscribe={handleSubscribe}
                        key={addon?.id}
                      />
                    )),
                  };
                })
                .filter(Boolean) as any[]}
            />
          </>
        ) : (
          <>
            <Text className="hero-text">
              For purchasing SMS add-on you have to purchase number first
            </Text>
            <Collapse
              accordion
              expandIconPosition="end"
              className="custom-collapse sms-addon-collapse"
              // {...(phoneNumberToUpdate ? { activeKey } : {})}
              // onChange={(key) => {
              //   customLogger(key);
              //   setActiveKey(key);
              // }}
              items={[
                {
                  key: "1",
                  label: customHeader("Purchase Number"),
                  children: (
                    <div style={{ height: "700px" }}>
                      <BuyNumbers
                        isPage={false}
                        handleBackToPrevious={() => {}}
                      />
                    </div>
                  ),
                },
              ]}
            />
          </>
        )}
      </div>

      <Modal
        className="custom-modal"
        open={paymentGatewayModalOpen}
        onCancel={() => setPaymentGatewayModalOpen(false)}
        footer={null}
      >
        <iframe
          title="payment gateway"
          src={paymentGatewayDetails?.url}
          width="100%"
          height="660px"
          style={{ border: "none" }}
          allowFullScreen
        />
      </Modal>
    </div>
  );
};

export default SMSAddons;
